import { CommonModule, NgClass } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faLock, faEnvelope, faUser,
  faBars
} from '@fortawesome/free-solid-svg-icons';
import { AppEnities, ExpiryStages } from '../common/constants.lib';

import _ from 'lodash';
import { LoggerService } from '../shared/logger.service';
import { AuthService } from '../auth/auth.service';
import { AuthTokenService } from '../auth/auth-token.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { User } from '../auth/me.lib';
import { TimeoutService } from '../auth/timeout.service';
import { MenuItem } from '../common/obj.lib';
import { SocketService } from '../shared/socket.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    FontAwesomeModule,
    NgClass
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {

  faLock = faLock;

  menu: any[] = [];
  private _isLoggedIn = new BehaviorSubject<boolean>(this.authTokenService.loggedIn);
  get isLoggedIn() {
    return this._isLoggedIn.getValue();
  }
  set isLoggedIn(val: boolean) {
    this._isLoggedIn.next(val);
  }

  private _expiryTime = new BehaviorSubject<number>(this.timeoutService.expiresIn);
  get expiryTime() {
    return this._expiryTime.getValue();
  }
  set expiryTime(val: number) {
    this._expiryTime.next(val);
  }

  //: boolean = this.authTokenService.loggedIn;
  me: User | null = null;

  refreshString: string | unknown = '';

  //#region Private

  private _subs: Subscription[] = [];
  // private previousStatus: boolean = this.authTokenService.isLoggedIn;

  private fullMenu = [
    MenuItem.create({ id: 0, title: "Home", url: "/home", entity: AppEnities.HOME }),
    MenuItem.create({ id: 0, title: "Test 1", url: "/test1", entity: AppEnities.TEST1 }),
    MenuItem.create({ id: 0, title: "Test 2", url: "/test2", entity: AppEnities.TEST2 }),
    MenuItem.create({ id: 0, title: "Test Grid", url: "/testgrid", entity: AppEnities.TESTGRID }),
  ];

  //#endregion

  constructor(
    public authService: AuthService,
    public authTokenService: AuthTokenService,
    library: FaIconLibrary,
    private logger: LoggerService,
    public timeoutService: TimeoutService,
    private socketService: SocketService
  ) {
    library.addIcons(faLock, faEnvelope, faUser, faBars);
  }

  //#region NG Event Handlers

  ngOnInit(): void {
    // this.logger.debug(`ngOnInit...`);
    this._subs.push(this.authTokenService.user$.subscribe(u => {
      this.me = u;
      this.buildMenu();
      // this.logger.debug('ngOnInit:me:', this.me);
    }));
    this._subs.push(this.authTokenService.isLoggedIn$.subscribe(status => {
      // this.logger.debug('status changed: **>> ', status);
      this.isLoggedIn = status;
    }));
    // this._subs.push(this.timeoutService.expiresIn$.subscribe(togo => {
    //   this.logger.debug(`expires in `, togo);
    // }));
    // this.timeoutService.startCountdown();

    // this._subs.push(this.socketService.onRefresh()
    //   .subscribe((message: any | unknown) => {
    //     this.logger.debug(`onRefresh: `, message);
    //     this.refreshString = message;
    //   }));

  }

  ngOnDestroy(): void {
    // this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
    this.timeoutService.stopCountdown();
  }

  //#endregion

  setClass(): string {
    if (this.timeoutService.expiryStage === ExpiryStages.Imminent) {
      return 'casi-imminent';
    } else if (this.timeoutService.expiryStage === ExpiryStages.Warning) {
      return 'casi-warning';
    } else if (this.timeoutService.expiryStage === ExpiryStages.Safe) {
      return 'casi-safe';
    } else {
      return 'casi-expired';
    }
  }

  signOut(): void {
    this.logger.debug('signOut...');

    this.authTokenService.removeToken();
    this.authService.logoutCall();

  };

  private buildMenu(): void {
    // this.logger.debug('buildMenu:fullMenu', this.fullMenu);
    // this.logger.debug('buildMenu:accessPermissions: ', this.authTokenService.getAccessClaims());
    this.menu = _.sortBy(this.fullMenu, "title").filter(m => {
      return true; // !(m as IMenuItem).entity;
    });

    // this.logger.debug('buildMenu:menu', this.menu);
  }

}
